import { render } from "./notification-no-company-item.vue?vue&type=template&id=b1f28a28"
import script from "./notification-no-company-item.vue?vue&type=script&lang=js"
export * from "./notification-no-company-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__